<template>
  <section>
    <directorio-form
      :is-add-new-sidebar-active.sync="isAddNewSidebarActive"
      :form-type="formType"
      :data-edit="dataEdit"
      @refetch-data="refetchData"
      @error-data="showError"
    />
    <modal-qr
      ref="refModalQr"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="card-transaction"
    >
      <b-card-header>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Mostrando</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="pageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>registros</label>
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <v-select
              v-model="ftPublicado"
              :reduce="m => m.value"
              label="text"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="publicadoOpc"
              :clearable="false"
              class="invoice-filter-select mr-1"
            >
              <template #selected-option="{ text }">
                <span class="text-truncate overflow-hidden">
                  {{ text }}
                </span>
              </template>
            </v-select>
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Buscar..."
            />
            <b-button
              variant="primary"
              @click="openForm('new')"
            >
              <span class="text-nowrap">Nuevo</span>
            </b-button>
          </div>
        </b-col>
      </b-card-header>

      <b-card-body>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="items"
          responsive
          :fields="fields"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No se encontraron registros"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">Cargando...</strong>
            </div>
          </template>
          <template #cell(nombres)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  rounded
                  class="avatar"
                  size="70"
                  variant="primary"
                  :src="
                    data.item.foto !== ''
                      ? `${pathMultimedia}/byUrl?isthumb=true&url=${data.item.foto}`
                      : '0'
                  "
                />
              </template>
              <span class="font-weight-bold d-block text-nowrap">
                {{ data.item.nombres }}
              </span>
              <small
                class="text-muted d-block "
              >
                {{ data.item.apellidos }}
              </small>
            </b-media>
          </template>
          <template #cell(orden)="data">
            <b-badge
              variant="dark"
            >
              {{ data.item.orden }}
            </b-badge>
          </template>
          <template #cell(esPublico)="data">
            <b-badge
              v-if="data.item.esPublico === 'SI'"
              variant="primary"
            >
              SI
            </b-badge>
            <b-badge
              v-else
              variant="light-secondary"
            >
              NO
            </b-badge>
          </template>
          <template #cell(cargo)="data">
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.cargo }}
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(acciones)="data">
            <b-button-toolbar justify>
              <b-button-group size="sm">
                <b-button
                  v-b-tooltip.hover.top="'Código QR'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="data.item.qr !== null && data.item.qr !== '' ? 'info' : 'secondary'"
                  @click="getCodeQR(data)"
                >
                  <feather-icon icon="GridIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.top="'Editar'"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="getEdit(data)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.top="'Eliminar'"
                  variant="danger"
                  class="btn-cart move-cart"
                  @click="getDelete(data)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="mr-50"
                  />
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ from }} a {{ to }} de {{ of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="page"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BButton, BTable, BBadge, BPagination, BSpinner, BMedia, BAvatar, BButtonToolbar, BButtonGroup, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import vSelect from 'vue-select'
import config from '@/services/config'
import DirectorioForm from './DirectorioForm.vue'
import ModalQr from '../code_qr/ModalQr.vue'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    DirectorioForm,
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BSpinner,
    BMedia,
    BAvatar,
    BButtonToolbar,
    BButtonGroup,

    vSelect,
    ModalQr,
  },
  data: () => ({
    ftPublicado: '',
    isAddNewSidebarActive: false,
    dataEdit: {},
    formType: '',
    isBusy: false,
    page: 1,
    perPage: 10,
    totalRows: 0,
    totalItems: 0,
    totalPage: 0,
    from: 0,
    to: 0,
    of: 0,
    pageOptions: [10, 20, 50],
    sortBy: null,
    sortDesc: false,
    sortDirection: 'asc',
    query: '',
    items: [],
    fields: [
      { key: 'idDirectorio', sortable: true, tdClass: 'd-none', thClass: 'd-none' },
      { key: 'nombres', label: 'Funcionario', sortable: true },
      { key: 'cargo', label: 'Cargo', sortable: true, tdClass: 'text-center', thClass: 'text-center' },
      { key: 'esPublico', label: '¿Es público?', sortable: true, tdClass: 'text-center', thClass: 'text-center' },
      { key: 'orden', sortable: true, tdClass: 'text-center', thClass: 'text-center' },
      { key: 'acciones' },
    ],
    publicadoOpc: [
      {
        text: 'Todos',
        value: '',
      },
      {
        text: 'SI',
        value: 'SI',
      },
      {
        text: 'NO',
        value: 'NO',
      },
    ],
    pathMultimedia: `${config.baseURL}${config.contextApi}/api/v1/multimedia`,
  }),
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
    ftPublicado: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    getCodeQR(data) {
      this.$refs.refModalQr.idSeccion = data.item.idDirectorio
      this.$refs.refModalQr.seccion = 'DIRECTORIO'
      this.$refs.refModalQr.srcQR = data.item.qr
      this.$refs.refModalQr.openModal()
    },
    listarRegistros() {
      this.isBusy = true
      store
        .dispatch('portal/DIRECTORIO_FIND_ALL', {
          esPublico: this.ftPublicado,
          tipo: 'grilla',
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'orden%7CASC',
        })
        .then(response => {
          this.items = response.items
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
          this.isBusy = false
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'Ha ocurrido un error',
            variant: 'danger',
            solid: true,
          })
          this.isBusy = false
        })
    },
    openForm(type) {
      this.formType = type
      this.isAddNewSidebarActive = true
    },
    getEdit(data) {
      this.formType = 'edit'
      this.isAddNewSidebarActive = true
      this.dataEdit = data.item
    },
    getDelete(data) {
      this.$swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store
            .dispatch('portal/DIRECTORIO_DELETE', {
              id: data.item.idDirectorio,
            })
            .then(response => {
              this.listarRegistros()
              this.$bvToast.toast('Ha Eliminado correctamente el registro.', {
                title: 'Operación Exitosa',
                variant: 'success',
                solid: true,
              })
              return response
            })
            .catch(error => {
              this.$bvToast.toast(error, {
                title: 'Ha ocurrido un error',
                variant: 'danger',
                solid: true,
              })
            })
        }
      })
    },
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.message
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.invoice-filter-select {
  min-width: 190px;
  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }
  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
